import BaseAPI from '../BaseAPI';
import { encryptDataString } from "utils";

class Barcode extends BaseAPI {
  constructor(props) {
    super(props);

    this.baseUrl = '/barcode';
  }

  /**
   * Fetches barcode
   * @param code
   * @return {Promise<*|Error>}
   */
  fetchBarcode(code) {
    const url = `${this.baseUrl}/${code}`;

    return this.get({ url });
  }

  /**
   * Fetches QR code
   * @param code
   * @return {Promise<*|Error>}
   */
  fetchQRCode(code) {
    let url = `${this.baseUrl}/generate-qr/${code}`;
    if (!this.getAccessToken()) {
      code = encryptDataString(code);
      url = `${this.baseUrl}/make-qr/${code}`;
    }

    return this.get({ url });
  }
}

export default Barcode;
